// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__3cmJ8","logo":"MainNavigation_logo__2WeB7","nav":"MainNavigation_nav__2VrMu","active":"MainNavigation_active__2FmwD"};